import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="The 12-volume curriculum" className="bg-ink" data-id="element-193" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: "19px"
    }} data-id="element-194" data-mp="1822b70ch9xit">
        <div className="text-center" data-id="element-195" data-mp="1c3e2rbewwstn">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold" data-id="element-196" data-mp="1zujhtod13h2w">
            🏆 THE ACADEMIC EDGE™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl" data-id="element-197" data-mp="24sus2078jtln">
            12 Volumes + 5 Bonuses
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-198" data-mp="1qwpngiytqxid">+100 pages — Everything solved.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-199" data-mp="1vvkgedqia2g7">
            {pillars.map(p => <span key={p} className="rounded-full border border-navy-soft/40 bg-navy/25 px-3 py-1 text-xs font-bold uppercase tracking-wide text-silver" data-id="element-200" data-mp="fdn02owgvzcr">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-silver" data-id="element-201" data-mp="3oa9bmtxr7hc9">
            📚 The 12-Volume Curriculum
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-202" data-mp="21q5m0ooqitc">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="group rounded-2xl border border-white/10 bg-ink-2 p-5 transition-colors duration-200 hover:border-gold/50" data-id="element-203" data-mp="3t6giqq1vyyvs" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-204" data-mp="fs3fi8l507lb">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-navy/50 font-display text-lg font-black text-gold" data-id="element-205" data-mp="fupn28812n3j">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-206" data-mp="wtze8lojo07t">
                  <span aria-hidden="true" data-id="element-207" data-mp="wrwhzjwstaun">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-208" data-mp="16rdjrq8xj4lc">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-gold/25 bg-ink-2 p-6" data-id="element-209" data-mp="1bjf664ztabp3">
          <p className="text-center font-display text-lg font-black text-gold" data-id="element-210" data-mp="1fl0ere5bc3th">
            ✅ Every volume includes
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-211" data-mp="1khqrpsltmjao">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/75" data-id="element-212" data-mp="1piy09tvsfmie">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={3} data-id="element-213" data-mp="1ug6n47rvsepz" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}